import React from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { getTranslation } from "orion-components/i18n";

const propTypes = {
    cardholder: PropTypes.object,
    filter: PropTypes.string,
    dir: PropTypes.string
};

const defaultProps = {
    cardholder: {},
    filter: ""
};

const CardHolder = ({ cardholder, filter, dir }) => {
    const { id, name, rank, image } = cardholder;

    const styles = {
        wrapper: {
            display: "flex"
        },
        label: {
            fontSize: 12,
            color: "#fff",
            opacity: 0.5
        },
        value: {
            fontSize: 14,
            color: "#fff"
        },
        detailBlock: {
            marginBottom: 13
        },
        details: {
            width: "50%",
            ...(dir === "rtl" ? { paddingRight: 20 } : { paddingLeft: 20 })
        },
        image: {
            maxWidth: "100%"
        }
    };

    const getStatus = () => {
        switch (filter) {
            case "valid-card-read":
                return getTranslation("global.profiles.widgets.cardHolder.validCardRead");
            case "invalid-card-read":
                return getTranslation("global.profiles.widgets.cardHolder.invalidCardRead");
            default:
                return "";
        }
    };

    return cardholder?.id ? (
        <div style={styles.wrapper}>
            <div style={{ width: "50%" }}>
                <img
                    alt={`image_${id}`}
                    style={styles.image}
                    src={image}
                />
            </div>
            <div style={styles.details}>
                <div style={styles.detailBlock}>
                    <Typography style={styles.label}>{getTranslation("global.profiles.widgets.cardHolder.status")}</Typography>
                    <Typography style={styles.value}>{getStatus()}</Typography>
                </div>
                <div style={styles.detailBlock}>
                    <Typography style={styles.label}>{getTranslation("global.profiles.widgets.cardHolder.name")}</Typography>
                    <Typography style={styles.value}>{name}</Typography>
                </div>
                <div style={styles.detailBlock}>
                    <Typography style={styles.label}>{getTranslation("global.profiles.widgets.cardHolder.id")}</Typography>
                    <Typography style={styles.value}>#{id}</Typography>
                </div>
                <div style={styles.detailBlock}>
                    <Typography style={styles.label}>{getTranslation("global.profiles.widgets.cardHolder.rank")}</Typography>
                    <Typography style={styles.value}>{rank}</Typography>
                </div>
            </div>
        </div >
    ) : <></>;
};


CardHolder.propTypes = propTypes;
CardHolder.defaultProps = defaultProps;

export default CardHolder;

